/**
 * Predefined activities with titles and seed names
 * Used by ActivityNameCombobox and ChatDevTools components
 */
export const PREDEFINED_ACTIVITIES = [
  { title: 'Cloze Math', seedName: 'M7-AyF-12a-A-3' },
  { title: 'Drag & Drop', seedName: 'M7-MyM-20a-E-1' },
  { title: 'Single Choice', seedName: 'M7-NyO-108a-I-2' },
  { title: 'Multiple Choice', seedName: 'M7-MyM-10a-I-3' },
  { title: 'Cloze with text', seedName: 'M7-G-13a-E-1' },
  { title: 'Dropdown', seedName: 'M7-G-65a-E-2' },
  { title: 'True or False', seedName: 'M7-EyP-9a-I-3' },
  { title: 'Numberline', seedName: 'M7-NyO-113a-I-6' },
  { title: 'Match List', seedName: 'M7-NyO-110a-I-1' },
  { title: 'Order List', seedName: 'M7-G-46a-E-2' },
  { title: 'Pie Chart', seedName: 'M7-EyP-14a-I-3' },
  { title: 'Bar Chart', seedName: 'M7-EyP-10a-I-2' },
  { title: 'Line Chart', seedName: 'M7-EyP-12a-I-1' },
  { title: 'Coordinate Axes', seedName: 'M7-AyF-12b-E-1' },
  { title: 'Label Image Drag & Drop', seedName: 'M7-G-20a-E-1' },
];

/**
 * Helper function to get seedName from activity title
 * @param {string} activityTitle - The activity title to lookup
 * @returns {string} The seedName if found in predefined activities, otherwise the title itself
 */
export const getSeedNameFromTitle = (activityTitle) => {
  if (!activityTitle) return '';

  // Look for matching predefined activity
  const predefinedActivity = PREDEFINED_ACTIVITIES.find((activity) => activity.title === activityTitle.trim());

  if (predefinedActivity) {
    return predefinedActivity.seedName;
  }

  // If not found in predefined activities, treat the entire title as a custom seedName
  return activityTitle.trim();
};
